import styled from "styled-components";

interface ICCapabilityHeader {
  color?: string
}

export const CapabilitiesContainer = styled.div`
  margin: 36px -25px 0;
  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 980px) {
    margin: 80px auto 0;
    max-width: 850px;
    overflow-x: auto;
  }
`

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  
  &:last-child {
    margin-bottom: 0;
  }

  @media (min-width: 980px) {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
`

export const Capability = styled.div`
  background: #F7F7FA;
  border-radius: 20px;
  min-width: 260px;
  margin: 0 18px;

  @media (min-width: 980px) {
    min-width: inherit;
    margin-bottom: 48px;
  }
`

export const CapabilityHeader = styled.div<ICCapabilityHeader>`
  background: ${({ color }) => color && color || '#fff'};
  font-weight: 700;
  font-size: 18px;
  line-height: 160%;
  color: #2A2637;
  padding: 18px;
  border-radius: 20px 20px 0 0;
  text-align: center;
`
export const CapabilityBody = styled.div`
  padding: 24px;
`
export const CapabilityList = styled.div``
export const CapabilityItem = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  
  &:last-child {
    margin-bottom: 0;
  }
`

export const CapabilityItemText = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: 160%;
  color: #2A2637;
`

export const CapabilityItemIcon = styled.span`
  margin-right: 12px;
`
